/**
 * List of colors according to the selection value, see `project_update.py`
 */
export const STATUS_COLORS = {
    'on_track': 20,
    'at_risk': 22,
    'off_track': 23,
    'on_hold': 21,
    'done': 24,
};

export const STATUS_COLOR_PREFIX = 'o_status_bubble mx-0 o_color_bubble_';
